import React from "react"

import './styles.css';
import { IBoasVindasItem } from "../../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/BoasVindas";
import WhiteContainer from "../../../../../components/Accessibility/WhiteContainer";
import DefaultText from "../../../../../components/Accessibility/DefaultText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sxLabel } from '../../../../../assets/styles/CommonSxProps';
import { Typography } from "@mui/material";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import { faCalendarHeart, faMonitorWaveform } from "@fortawesome/pro-duotone-svg-icons";

const iconMap: Record<string, any> = {
    "fas fa-heartbeat": faMonitorWaveform,
    "fas fa-calendar-day": faCalendarHeart
};

interface InformationCardProps {
    item: IBoasVindasItem
}

export const InformationCard: React.FC<InformationCardProps> = ({ item }: InformationCardProps) => {
    const accessibility = useAccessibility();
    const icon = iconMap[item.icon] || faMonitorWaveform;

    return (
        <WhiteContainer className="information-card-container" key={item.subtitulo}>
            <FontAwesomeIcon icon={icon} className='information-card-container-icon' color="#00995D" />
            <div>
                <Typography sx={sxLabel} style={accessibility.textStyleAccessibility}>
                    {item.subtitulo}
                </Typography>
                <DefaultText text={item.texto} />
            </div>
        </WhiteContainer>
    )
}